import React, { useState } from "react";
import mockSecureWebApp from "../assets/images/arch.png";
import mockSecureWebsite from "../assets/images/mock02.png";
import mockMalware from "../assets/images/rat.jpg";
import mockAuctionLedger from "../assets/images/bc.jpg";
import mockMopsus from "../assets/images/logo.png";
import "../assets/styles/Project.scss";

function Project() {
    const [currentPage, setCurrentPage] = useState(1);
    const projectsPerPage = 4;

    const projects = [
        {
            title: "Mopsus",
            href: "https://github.com/leandrocosta-git/mopsus",
            description: "Open-source insider threat detection platform that monitors user behavior, infrastructure changes, and security violations in real time across AWS, GCP, and Azure.",
            image: mockMopsus,
            alt: "Mopsus dashboard thumbnail",
        },
        {
            title: "Secure Web App",
            href: "https://github.com/leandrocosta-git/secure-web-app",
            description: "AWS-hosted web application with hardened infrastructure: VPC, ALB, WAF, OIDC authentication, and CI/CD pipeline.",
            image: mockSecureWebApp,
            alt: "secure-web-app thumbnail",
        },
        {
            title: "Secure Website",
            href: "https://github.com/leandrocosta-git/secure-website",
            description: "Static website deployment with CloudFront + S3, HTTPS/TLS, WAF rules, and least-privilege IAM for secure-by-design hosting.",
            image: mockSecureWebsite,
            alt: "secure-website thumbnail",
        },
        {
            title: "TPAS Malware",
            href: "https://github.com/leandrocosta-git/TPAS_malware",
            description: "Research and implementation of malware tooling and RATs in Python/PowerShell/C, developed for academic and security analysis use.",
            image: mockMalware,
            alt: "TPAS malware thumbnail",
        },
        {
            title: "Secure Auction Ledger",
            href: "https://github.com/DiogoAlexandreOliveiraDaSilva/secure-auction-ledger",
            description: "Public auction ledger implemented in Rust with Proof-of-Work and peer-to-peer communication for secure distributed transactions.",
            image: mockAuctionLedger,
            alt: "secure-auction-ledger thumbnail",
        },
    ];

    const totalPages = Math.ceil(projects.length / projectsPerPage);
    const visibleProjects = projects.slice(
        (currentPage - 1) * projectsPerPage,
        currentPage * projectsPerPage,
    );

    return (
        <div className="projects-container" id="projects">
            <h1>Personal Projects</h1>
            <div className="projects-grid">
                {visibleProjects.map((project) => (
                    <div className="project" key={project.title}>
                        <div className="project-text">
                            <a href={project.href} target="_blank" rel="noreferrer">
                                <h2>{project.title}</h2>
                            </a>
                            <p>{project.description}</p>
                        </div>
                        <div className="project-image">
                            <a href={project.href} target="_blank" rel="noreferrer">
                                <img src={project.image} className="zoom" alt={project.alt} />
                            </a>
                        </div>
                    </div>
                ))}

            </div>

            {totalPages > 1 && (
                <div className="projects-pagination" aria-label="Projects pagination">
                    <button
                        type="button"
                        className="projects-pagination-button"
                        onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
                        disabled={currentPage === 1}
                        aria-label="Previous projects"
                    >
                        ‹
                    </button>

                    <button
                        type="button"
                        className="projects-pagination-button"
                        onClick={() => setCurrentPage((page) => Math.min(totalPages, page + 1))}
                        disabled={currentPage === totalPages}
                        aria-label="Next projects"
                    >
                        ›
                    </button>
                </div>
            )}
        </div>
    );
}

export default Project;
